/**
 * Index/list routes: grant access if the user has any of these permissions
 * (backend often assigns `*-view` or `*-edit` without a separate `*-list`).
 * Keys must match `path.jsx` list paths and `sidebarConfig` item paths.
 */
export const LIST_ROUTE_ANY_PERMISSIONS = {
  "/brands": ["brand-list", "brand-view", "brand-edit"],
  "/invoices": ["invoice-list", "invoice-view", "invoice-edit"],
  "/payments": ["payment-list", "payment-view"],
  "/orders": ["order-list", "order-view", "order-edit"],
  "/payment-errors": ["payment-error-list", "payment-error-view"],
  "/payment-accounts": [
    "payment-account-list",
    "payment-account-list-front",
    "payment-account-view",
    "payment-account-edit",
  ],
  "/tasks": ["task-list", "task-view", "task-edit"],
  "/services": ["service-list", "service-view", "service-edit"],
  "/companies": ["company-list-front", "company-view", "company-edit"],
  "/task-types": ["task-type-list", "task-type-view", "task-type-edit"],
  "/task-categories": [
    "task-category-list",
    "task-category-view",
    "task-category-edit",
  ],
  "/task-templates": [
    "task-template-list",
    "task-template-view",
    "task-template-edit",
  ],
  "/lead-quizzes": ["lead-quiz-list", "lead-quiz-view", "lead-quiz-edit"],
  "/roles": ["role-list", "role-view", "role-edit"],
  "/customers-list": [
    "customer-list",
    "customer-list-front",
    "customer-view",
    "customer-edit",
  ],
};
